module.exports = __webpack_public_path__ + "img/10551382_L.4a496951.png";